import styled from 'styled-components';
import { THEME_COLORS } from '../utils/theme';

export const Label = styled.label`
  color: ${THEME_COLORS.text};
  padding: 20px 10px 10px;
  font-weight: 400;
`;

interface FormProps {
  error?: boolean;
}

export const Input = styled.input<FormProps>`
  width: 400px;
  height: 30px;
  margin: 10px;
  padding: 2px 5px;

  background: ${THEME_COLORS.backgroundForm};
  border: 2px solid ${({ error }) => (error ? 'darkred' : 'black')};
  border-radius: 3px;
  color: ${THEME_COLORS.text};

  ::placeholder {
    color: ${THEME_COLORS.textDim};
  }
`;

export const TextArea = styled.textarea`
  width: 600px;
  margin: 10px;
  line-height: 1.2em;
  padding: 2px 5px;

  background: ${THEME_COLORS.backgroundForm};
  border: 2px solid black;
  border-radius: 3px;
  color: ${THEME_COLORS.text};
`;

export const Button = styled.button`
  background: ${THEME_COLORS.brandPinkFaded};
  color: ${THEME_COLORS.text};

  padding: 12px 30px;

  border: none;
  border-radius: 5px;

  font-size: 14px;
  font-weight: 600;

  &:hover {
    background: ${THEME_COLORS.brandPink};
    cursor: pointer;
  }
`;

export const LinkButton = styled.a`
  background: ${THEME_COLORS.brandPinkFaded};
  color: ${THEME_COLORS.text};
  text-decoration: none;

  padding: 12px 30px;

  border: none;
  border-radius: 5px;

  font-size: 14px;
  font-weight: 600;

  &:hover {
    background: ${THEME_COLORS.brandPink};
    cursor: pointer;
  }
`;

export const FormRow = styled.div`
  display: flex;
  flex-flow: row nowrap;

  justify-content: flex-start;
  align-items: center;
`;
